import React from "react";
import { Routes, Route, Outlet } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";

/// Pages
import Error404 from "./common/Error404";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";

import Dashboard from "./pages/Dashboard";

// AdminSetting
import Permission from "./pages/StaffManagment/CustomRules";
import AddPermission from "./pages/StaffManagment/CustomRules/AddRole";
import Admins from "./pages/StaffManagment/Admin";
import Zones from "./pages/Zones";
import AddZones from "./pages/Zones/AddZones";
import ParkingSlots from "./pages/Parking/ParkingSlots";
import WorkShifts from "./pages/Settings/WorkShift";
import Parking from "./pages/Parking/Parking";
import AddParking from "./pages/Parking/Parking/AddParking";
import Drivers from "./pages/DriversManagment/Drivers";
import Notification from "./pages/Notification";
import PaymentLink from "./pages/PaymentLink";
import Users from "./pages/Users";
import AddNotification from "./pages/Notification/AddNotification";
import QuickValet from "./pages/Parking/QuickValet";
import Requests from "./pages/DriversManagment/Requests";
import QrCodeGrouping from "./pages/Parking/QrCodeGrouping";
import QrCodeValet from "./pages/Parking/QrCodeValet";
import CodeParking from "./pages/Parking/CodeParking";
import StaffDrivers from "./pages/Reports/StaffDrivers";
import ZonesReport from "./pages/Reports/Zones";
import AverageServiceTime from "./pages/Reports/AverageServiceTime";
import Iban from "./pages/Settings/Iban";
import PaymentReport from "./pages/Reports/PaymentReport";

const Markup = () => {
	const allroutes = [
		// Dashboard
		{ url: "/", component: <Dashboard /> },

		// Staff Managment
		{ url: "/admins", component: <Admins /> },
		{ url: "roles", component: <Permission /> },
		{ url: "roles/add_role", component: <AddPermission /> },
		{ url: "roles/:id", component: <AddPermission /> },

		// Zones Managment
		{ url: "zones", component: <Zones /> },
		{ url: "add-zone", component: <AddZones /> },

		// Parking Slots
		{ url: "parking-slots", component: <ParkingSlots /> },
		{ url: "parking", component: <Parking /> },
		{ url: "parking/add-parking", component: <AddParking /> },
		{ url: "quick-valet", component: <QuickValet /> },
		{ url: "qr-code-grouping", component: <QrCodeGrouping /> },
		{ url: "qr-code-valet", component: <QrCodeValet /> },
		{ url: "qr-parking", component: <CodeParking /> },

		// Setting
		{ url: "work-shifts", component: <WorkShifts /> },
		{ url: "iban", component: <Iban /> },

		// Drivers
		{ url: "/drivers", component: <Drivers /> },
		{ url: "/requests", component: <Requests /> },

		// Users
		{ url: "/users", component: <Users /> },

		// Reports
		{ url: "/staff-drivers", component: <StaffDrivers /> },
		{ url: "/zones-report", component: <ZonesReport /> },
		{ url: "/average-service-time", component: <AverageServiceTime /> },
		{ url: "/payment-report", component: <PaymentReport /> },

		// Profile
		// { url: "profile", component: <Profile /> },

		// Notification
		{ url: "notification", component: <Notification /> },
		{ url: "notification/add-notification", component: <AddNotification /> },
		{ url: "notification/edit-notification", component: <AddNotification /> },

		// Payment Link
		{ url: "payment-link", component: <PaymentLink /> },

		// Error
		{ url: "*", component: <Error404 /> },
	];

	return (
		<>
			<Routes>
				<Route path="page-error-404" element={<Error404 />} />
				<Route element={<MainLayout />}>
					{allroutes.map((data, i) => (
						<Route
							key={i}
							exact
							path={`${data.url}`}
							element={data.component}
						/>
					))}
				</Route>
			</Routes>
			<ScrollToTop />
		</>
	);
};

function MainLayout() {
	return (
		<div id="main-wrapper overflow-auto" className={`show `}>
			<Nav />
			<div
				className="content-body"
				style={{ minHeight: window.screen.height - 45 }}>
				<div className="container-fluid">
					<Outlet />
				</div>
			</div>
		</div>
	);
}

export default Markup;
